var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { createInertiaApp } from '@inertiajs/react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import Layout from '@/Shared/Layout';
Sentry.init({
    dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
    release: process.env.MIX_SENTRY_RELEASE,
    integrations: [
        Sentry.replayIntegration()
        // Sentry.feedbackIntegration({
        //   // Additional SDK configuration goes in here, for example:
        //   showBranding: false,
        //   showName: false,
        //   showEmail: false,
        //   formTitle: '',
        //   messagePlaceholder:
        //     'Please describe the bug, the expected behavior and how to recreate the issue, if possible'
        // })
    ],
    // Session Replay
    replaysSessionSampleRate: parseFloat(process.env.REPLAY_SESSION_SAMPLE_RATE) || 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: parseFloat(process.env.REPLAY_ON_ERROR_SAMPLE_RATE) || 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
createInertiaApp({
    resolve: (name) => __awaiter(void 0, void 0, void 0, function* () {
        const page = yield import(`./Pages/${name}`);
        page.default.layout =
            page.default.layout || (({ children }) => React.createElement(Layout, null, children));
        return page;
    }),
    setup({ el, App, props }) {
        createRoot(el).render(React.createElement(App, Object.assign({}, props)));
    },
    progress: {
        color: '#ED8936',
        showSpinner: true
    }
});
